import {
  COMMUNITY_WORLD_SLUGS,
  SAT_BOOTCAMP_WORLD_SLUG,
  SCHOOL_PARTNERSHIP_WORLD_SLUGS,
} from './constants'
import type { WorldType } from './types'

export default function getWorldType({ worldSlug }: { worldSlug: string }): WorldType {
  if (COMMUNITY_WORLD_SLUGS.includes(worldSlug)) {
    return 'non-academic'
  }

  if (worldSlug === SAT_BOOTCAMP_WORLD_SLUG) {
    return 'sat-bootcamp'
  }

  if (SCHOOL_PARTNERSHIP_WORLD_SLUGS.includes(worldSlug)) {
    return 'school-partnership'
  }

  return 'academic'
}
